import gql from "graphql-tag";

export const MY_LEAVE_GET_TYPES_BY_CONTRACT = gql`
  query leaveTypesByContract(
    $contract: String!
    $startDate: Date!
    $endDate: Date!
  ) {
    leaveTypesByContract(
      contract: $contract
      startDate: $startDate
      endDate: $endDate
    ) {
      code
      name
      type
    }
  }
`;
